module.exports = __webpack_public_path__ + "img/support_migrant_rights.96f83554.jpeg";